module.exports = __webpack_public_path__ + "static/img/banner_inner.23240de4.gif";